import Excel from 'exceljs'
import saveAs from 'file-saver'

export function createAndDownloadWorksheet(fileName, tabName, header, rows, name) {
  const workbook = new Excel.Workbook()

  workbook.creator = name
  workbook.lastModifiedBy = name
  workbook.created = new Date()
  workbook.modified = new Date()

  workbook.views = [
    {
      x: 0, y: 0, width: 10000, height: 20000,
      firstSheet: 0, activeTab: 1, visibility: 'visible'
    }
  ]

  const worksheet = workbook.addWorksheet(tabName)

  worksheet.columns = header
  worksheet.addRows(rows)

  workbook.xlsx.writeBuffer().then((data) => {
    const blob = new Blob([data], {type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'})
    saveAs(blob, fileName)
  })
}
